<app-header></app-header>
<app-page-title></app-page-title>

<div class="col-lg-12">
  <div class="row">

    <div class="col-md-2 col-lg-2-5">
      <div class="search-label">Select Region</div>
      <select [(ngModel)]="regionFilter" class="form-control" (change) = "getCategoryList($event)">
        <option value=""> All Region </option>
        <option *ngFor="let regionRow of regionList"  value="{{regionRow.region_name}}"> {{regionRow.region_name}} </option>
      </select>
    </div>
    <div class="col-md-2 col-lg-3-5">
      <div class="search-label">Category Type</div>
      <select [(ngModel)]="categoryFilter" class="form-control" (change) = "getTimeUnitList($event)">
        <option value=""> All Category Type </option>
        <option *ngFor="let category of categoryList"  value="{{category.industry_category}}">{{category.industry_category}}</option>
      </select>
    </div>
    <div class="col-md-2 col-lg-4-5">
      <div class="search-label">Industry Type</div>
      <select [(ngModel)]="unitTypeFilter" class="form-control" (change) = "getVendorList($event)">
        <option value=""> All Industry Type </option>
        <option *ngFor="let item of timeUnitList"  value="{{item.stdunit}}"> {{item.stdunit}} </option>
      </select>
    </div>
    <div class="col-md-2 col-lg-4-5">
      <div class="search-label">Vendor</div>
      <select [(ngModel)]="vendorFilter" class="form-control" (change) = "getIndustryList($event)">
        <option value=""> All Vendor</option>
        <option *ngFor="let vendor of vendorList"  value="{{vendor.id}}"> {{vendor.vendor_name}} </option>
      </select>

    </div>
    <div class="col-md-2 col-lg-4-5">
      <div class="search-label"> Industry </div>
      <ng-multiselect-dropdown
        class="form-control multi"
        [data]="industryList"
        [(ngModel)]="industryFilter"
        [settings]="industrySettings"
        (onSelect)="getStationList($event)"
        (onSelectAll)="getStationList($event)"
        (onDeSelect)="getStationList($event)"
      >
      </ng-multiselect-dropdown>
    </div>
    <div class="col-md-2 col-lg-4-5">
      <div class="search-label">Station</div>
      <ng-multiselect-dropdown
        class="form-control multi"
        [data]="stationList"
        [(ngModel)]="stationFilter"
        [settings]="stationSettings"
      >
      </ng-multiselect-dropdown>
    </div>
  </div>


  <div class="col-lg-12 center m-y">
    <button class="btn btn-primary" (click)="getExceededIndustry()" > <i class="icon icon-search4"></i> Search </button>
  </div>
</div>

<div class="page-container">

  <!-- Page content -->
  <div class="page-content">

    <!-- Main content -->
    <div class="content-wrapper">

      <div class="row">

        <div *ngIf="firstLevelExceedance" class="panel panel-flat">
          <div class="panel-body">
            <div class="col-md-9 h5 text-justify" style="padding-left: 0;">
               <span>OCEMS Station & parameter monitoring Abstract Report of {{regionFilter}} Region as on {{currentDate}}
                 .</span>
            </div>

            <div class=" col-md-3" style="text-align: right;" >
              <button style="margin-right: 10px; cursor: pointer !important;" type="button" class="btn btn-xs btn-info"><strong>Total Regions </strong>  <span class="badge badge-info">{{firstLevelExceedance.length}}</span></button>
              <a title="Export Excel." (click)="exportReportFirstLevel('excel')" style="background-color: #EEF3F6; font-weight: 900 !important; color: #000 !important;" class="btn border-primary text-primary btn-flat btn-icon btn-rounded btn-sm">
                <i class="icon icon-file-excel"></i>
              </a>
              <a id="exportexcelhrefFirstLevel" target="_blank"></a>&nbsp;
              <!-- <a title="Export PDF." (click)="exportReportFirstLevel('pdf')" style="background-color: #EEF3F6; font-weight: 900 !important; color: #000 !important; margin-right: 10px;" class="btn border-primary text-primary btn-flat btn-icon btn-rounded btn-sm">
                <i class="icon icon-file-pdf"></i>
              </a>
              <a id="exportpdfhrefFirstLevel" target="_blank"></a> -->
            </div>
          </div>

          <table *ngIf="!regionLoaderExceedance" class="table datatable-show-all">
            <thead>
            <tr>
              <th>Region Name</th>
              <th>Name of Officer</th>
              <th>Number of Emission station in region</th>
              <th>Number of Effluent station in region</th>
              <th>Number of Emission/effluent station in region</th>
              <th>Detail</th>

            </tr>
            </thead>

            <tbody>
            <tr *ngFor="let region of firstLevelExceedance">
              <td>{{region.region_name}}</td>
              <td>{{region.officer_name}}</td>
              <td>{{region.emmision}}</td>
              <td>{{region.effluent}}</td>
              <td>{{region.emmision_effluent}}</td>
              <td>
                <a *ngIf="region.emmision || region.effluent || region.emmision_effluent" (click)="getExceedanceIndustryList(region.total_station_ids)" data-toggle="modal" data-target="#secondLevel">View</a>
              </td>
            </tr>
            <tr>
              <td colspan="2">Total</td>
              <td *ngIf="emmisionsSum()>0"> <a (click)="getStationIDs('total_station_ids', 'air')"> {{ emmisionsSum() }}</a></td>
              <td *ngIf="emmisionsSum()<=0"> {{ emmisionsSum() }}</td>

              <td *ngIf="effluentSum()>0"> <a (click)="getStationIDs('total_station_ids', 'water')"> {{ effluentSum() }}</a></td>
              <td *ngIf="effluentSum()<=0"> {{ effluentSum() }}</td>

              <td *ngIf="emmisionEffluentSum()>0"> <a (click)="getStationIDs('total_station_ids', 'both')"> {{ emmisionEffluentSum() }}</a></td>
              <td *ngIf="emmisionEffluentSum()<=0"> {{ emmisionEffluentSum() }}</td>

              <td><button id="openModalButton" [hidden]="true" data-toggle="modal" data-target="#secondLevel">Open Modal</button></td>
            </tr>
            </tbody>
          </table>
          <div *ngIf="regionLoaderExceedance">
            <div colspan="12" class="col-lg-12 text-center" style="height: 180px;">
              <div style="margin-top: 50px;">
                <img src="/assets/images/load.gif" />
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="!firstLevelExceedance"  class="col-lg-12 text-center" style="height: 180px;">
          <div style="font-size: 28px; font-weight: 600; color: red; margin-top: 50px;">
            No Industry Station Report Found
          </div>
        </div>

        <div id="secondLevel" class="modal fade" role="dialog">
          <div class="modal-dialog">

            <!-- Modal content-->
            <div class="modal-content">

              <div class="modal-header">
                <div class="panel-body">
                  <div class="col-md-10 h5 text-justify" style="padding-left: 0;">
                    <span> Detailed OCEMS Station & parameter monitoring Abstract Report of {{regionFilter}} Region as on {{currentDate}}
                      .</span>
                  </div>

                  <div class=" col-md-2" style="text-align: right;" >
                    <a title="Export Excel." (click)="exportReportSecondLevel('excel')" style="background-color: #EEF3F6; font-weight: 900 !important; color: #000 !important;" class="btn border-primary text-primary btn-flat btn-icon btn-rounded btn-sm">
                      <i class="icon icon-file-excel"></i>
                    </a>
                    <a id="exportexcelhrefSecondLevel" target="_blank"></a>&nbsp;
                    <!-- <a title="Export PDF." (click)="exportReportSecondLevel('pdf')" style="background-color: #EEF3F6; font-weight: 900 !important; color: #000 !important; margin-right: 10px;" class="btn border-primary text-primary btn-flat btn-icon btn-rounded btn-sm">
                         <i class="icon icon-file-pdf"></i>
                    </a>
                    <a id="exportpdfhrefSecondLevel" target="_blank"></a> -->
                    <button type="button" class="closeModal" data-dismiss="modal">&times;</button>
                  </div>
                </div>

              </div>

              <div class="modal-body">
                <div class="table-responsive" *ngIf="!moreDetailDrilledExceedance">
                  <table class="table datatable-show-all">
                    <thead>
                      <tr>
                      <th>HROCMMs ID</th>
                      <th>Industry name</th>
                      <th>Industry address</th>
                      <th>Region</th>
                      <th> Category Type</th>
                      <th>Vendor name</th>
                      <th>Name of stations</th>
                      <th>Name of parameters with stations</th>
                      <th>Device status</th>
                      <th>Owner name</th>
                      <th>Owner email</th>
                      <th>Owner Mobile number</th>
                      <th>Latitude longitude</th>
                      <th>Consent Certificate</th>
                      </tr>
                   </thead>

                    <tbody *ngIf="!industryLoaderExceedance">
                      <tr *ngFor="let industry of secondLevelExceedance">
                        <td>{{industry.hr_ocmms_id}}</td>
                        <td>{{industry.industry_name}}</td>
                        <td>{{industry.industry_address}}</td>
                        <td>{{industry.region_name}}</td>
                        <td>{{industry.industry_category}}</td>

                        <td>
                          <div *ngFor="let vendor of industry.vendor_name">
                            {{vendor}},<br><br>
                          </div>
                        </td>

                        <td>
                          <div *ngFor="let item of industry.station_name | keyvalue">
                            {{item.value}}, <br><br>
                          </div>
                        </td>


                        <td>
                          <div *ngFor="let key of industry.parameters">
                            <b>{{key.station_name}}</b><br>
                            <ng-container *ngFor="let item of key.parameter | keyvalue">
                              <span *ngIf="item.value">{{item.value}},</span>
                            </ng-container>
                            <br>
                          </div>
                          <br>
                        </td>

                        <td>{{industry.device_status}}</td>
                        <td>{{industry.owner_name}}</td>
                        <td>{{industry.owner_email}}</td>
                        <td>{{industry.owner_number}}</td>
                        <td>{{industry.latitude}},{{industry.longitude}}</td>
                        <td>
                          <button *ngIf="industry.certificate">
                            <a style="text-decoration: none;" download href="{{industry.certificate}}" target="_blank">
                              Certificate
                            </a>
                          </button>
                          <button *ngIf="!industry.certificate">
                            <a style="text-decoration: none;" href="#" target="_blank">
                              NA
                            </a>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                    <tbody *ngIf="industryLoaderExceedance" >
                    <tr>
                      <td colspan="12" class="col-lg-12 text-center" style="height: 180px;">
                        <div style="margin-top: 50px;">
                          <img src="/assets/images/load.gif" />
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

